<template>
    <div class="aiTitle_container global_container_center" v-if="isShow">
      <div class="aiTitle_main">
        <div class="aiTitle_close" @click="doClose">
          <el-icon><Close /></el-icon>
        </div>
        <div class="aiTitle_tip">
          <span style="color: #e64638"> 温馨提示：</span>
          应基金会要求，每场会议需要有一个副标题辅助大家进行讨论，请选择以下满足帖子立意的副标题
        </div>
        <div class="aiTitle_title">
          <el-radio-group v-model="ai_title">
            <el-radio
              v-for="(item, index) in titleList"
              :key="index"
              :value="item"
              :label="item"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </div>
  
        <div class="aiTitle_button_group">
          <CustomButton size="small" type="primary" @click="doCommit"
            >确认选择</CustomButton
          >
        </div>
        <div class="aiTitle_tips" @click="getAiTitle(false)">
          以上都不是，换一批（{{ count }}/3）
        </div>
      </div>
    </div>
  </template>
  <script>
  import CustomButton from "../../unit/CustomButton.vue";
  import { ElRadioGroup, ElRadio } from "element-plus";
  import PopopInstance from "@/components/unit/PopupInstance";
  import { Close } from "@element-plus/icons";
  export default {
    name: "publish",
    components: {
      CustomButton,
      ElRadioGroup,
      ElRadio,
      Close,
    },
    props: {
      info: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        loading: false,
        ai_title: "",
        count: -1,
        titleList: [
          // "替雷利珠单抗是如何具体开启肺癌免疫治疗全人群治疗时代的？",
          // "相比其他药物，替雷利珠单抗引领肺癌免疫治疗全人群治疗时代的优势在哪里？",
          // "在替雷利珠单抗引领的肺癌免疫治疗全人群治疗时代，患者的获益情况有哪些显著变化？",
          // "替雷利珠单抗引领肺癌免疫治疗全人群治疗时代，会对传统肺癌治疗模式带来怎样的冲击和改变？",
          // "未来替雷利珠单抗在巩固肺癌免疫治疗全人群治疗时代方面还需要进行哪些探索？ ",
        ],
        msg: {
          title: "温馨提示",
          html: `<div class="popup-content-main">
               更换下一批将清空您当前选中的内容，且不可逆，请确认是否换一批</span>
                </div>`,
          btngroup: { sure: "确认", close: "取消" },
          align: "center",
        },
        isShow: false,
      };
    },
    mounted() {
      this.getAiTitle(true);
    },
    methods: {
      getAiTitle(status) {
        if (status) {
          this.ai_title = this.$tools.getStorage("ai_title");
          this.titleList = this.$tools.getStorage("ai_title_data")?.data || [];
          this.count =
            this.$tools.getStorage("ai_title_data")?.count == undefined
              ? -1
              : this.$tools.getStorage("ai_title_data")?.count == 0
              ? 0
              : this.$tools.getStorage("ai_title_data")?.count;
  
          if (this.titleList.length) return (this.isShow = true);
        }
        if (this.count == 3) {
          this.$tips.error({ text: "您当前换一批的次数已达上限" });
          return;
        }
        if (this.ai_title && status == false) {
          PopopInstance(this.msg)
            .then(() => {
              this.ai_title = "";
              this.uploadTitle();
            })
            .catch(() => {});
        } else {
          this.uploadTitle();
        }
      },
  
      uploadTitle() {
        let currLoading = this.$tips.loading();
        this.loading = true;
        if (this.count < 3) {
          this.count += 1;
          this.$axios
            .post(this.$urls.live.aiTitle, { title: this.info.title })
            .then((res) => {
              this.titleList = res.data;
              this.$tools.setStorage("ai_title_data", {
                data: res.data,
                count: this.count,
              });
              this.isShow = true;
              currLoading.close();
              this.loading = false;
            })
            .catch(() => {
              currLoading.close();
              this.loading = false;
            });
        }
      },
      doCommit() {
        if (!this.ai_title) {
          this.$tips.error({ text: "请先选择副标题" });
          return;
        }
        if (this.loading) return;
        this.loading = true;
        this.$tools.setStorage("ai_title", this.ai_title);
        // this.$tools.setStorage("ai_title_count", this.ai_title);
        this.$emit("doComfirm");
        // this.$axios
        //   .patch(this.$urls.live.mode, { ...this.$route.query, post_type: 1 })
        //   .then((res) => {
        //     setTimeout(() => {
        //       this.loading = false;
        //     }, 1000);
        //   })
        //   .catch(() => {
        //     setTimeout(() => {
        //       this.loading = false;
        //     }, 1000);
        //     this.$tips.error({ text: "操作失败" });
        //   });
      },
      doClose() {
        this.$emit("doComfirm");
      },
    },
  };
  </script>
  <style>
  .aiTitle_container {
    /* height: 60%; */
    width: 95%;
    font-size: 0.8rem;
    font-weight: 600;
    background: #fff;
    border: 1px solid #ccc;
    padding: 1rem;
    z-index: 99;
  }
  
  .aiTitle_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.5rem;
    /* text-align: center; */
  }
  .aiTitle_title {
    flex: 1 0 0;
    width: 100%;
    margin-top: 1rem;
  }
  .aiTitle_close {
    width: 100%;
    text-align: end;
    margin-right: -20px;
    color: #e64638;
  }
  
  .aiTitle_close svg {
    width: 20px;
  }
  .aiTitle_title .el-radio-group {
    flex-direction: column;
  }
  .aiTitle_title .el-radio-group .el-radio:last-child {
    margin-right: auto !important;
  }
  .aiTitle_button_group {
    display: flex;
    margin: 1.5rem 0;
  }
  .aiTitle_tips {
    color: #ccc;
    font-size: 0.8rem;
    border-bottom: 1px solid #ccc;
    line-height: 1;
    /* text-decoration: underline; */
  }
  .aiTitle_title .el-radio {
    height: auto !important;
    white-space: pre-wrap;
    margin-right: 0 !important;
    margin-bottom: 10px !important;
    width: 100% !important;
  }
  </style>